import React, { useEffect, useState } from "react";
import { ServiceSection } from "../../../AdminStyle.styled";
import { Row, Col, Button, Table, Modal, Pagination } from "antd";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import {
  CreateProductInventory,
  UpdateProductInventory,
  DeleteProductInventory,
  GetAllProductInventory,
  GetOneConfiguredServices,
  GetAllProducts,
  GetAllRawMaterials,
} from "../../../../../../redux/actions/adminActions";
import { Delete, Edit, Save, Add } from "@mui/icons-material";
import ProducesModal from "./CreateProducesModal";
import { formatDateObjectHandler } from "../../../../../../utils";
import ViewDetailsModal from "./ViewDetailsModal";

const Produces = (props) => {
  const {
    CreateProductInventory,
    UpdateProductInventory,
    allProductInventory,
    GetAllProductInventory,
    DeleteProductInventory,
    GetAllProducts,
    allProducts,
    GetAllRawMaterials,
    allRawMaterials,
    my_roles,
    user_details,
  } = props;

  const [deleteLoading, setDeleteLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [openDetails, setOpenDetails] = useState(false);
  const [formMode, setFormMode] = useState("CREATE_MODE");
  const [productRecord, setProductRecord] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: allProductInventory?.length,
  });

  const editRecord = async (record) => {
    setProductRecord(record);
    setVisible(true);
    setFormMode("UPDATE_MODE");
  };
  const deleteRecord = (record) => {
    Modal.confirm({
      title: "Do you want to delete this record?",
      content: "Click yes to proceed",
      okText: "Delete",
      loading: deleteLoading,
      okType: "danger",
      async onOk() {
        setDeleteLoading(true);
        const res = await DeleteProductInventory(record.id);
        if (res.success) {
          setDeleteLoading(false);
          toast.success(res.message, {
            pauseOnHover: false,
          });
        } else {
          toast.info(res.message, {
            pauseOnHover: true,
          });
        }
      },
      onCancel() {
        setDeleteLoading(false);
        return false;
      },
    });
  };
  const CreateService = () => {
    setVisible(true);
    setFormMode("CREATE_MODE");
    setProductRecord(null);
  };

  const closeModal = () => {
    setVisible(false);
    setFormMode("CREATE_MODE");
    setProductRecord(null);
  };
  const privileges = my_roles[0]?.role?.privileges;

  const recordColumn = [
    {
      title: "ID",
      dataIndex: "id",
    },
    {
      title: "Product",
      dataIndex: "name",
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
    },
    {
      title: "Raw Materials (NO)",
      dataIndex: "raw_material",
      render: (_text, record) => <p>{record?.raw_materials?.length}</p>,
    },
    {
      title: "Date Created",
      dataIndex: "date_created",
      align: "center",
      render: (_text, record) => (
        <>
          {formatDateObjectHandler(record.date_created, "Do MMM YYYY")} <br />
        </>
      ),
    },
    {
      title: "action",
      dataIndex: "action",
      align: "center",
      render: (_text, record) => (
        <div className="actiontable">
          <button
            className="del"
            onClick={() => {
              setProductRecord(record);
              setOpenDetails(true);
            }}
          >
            View
          </button>
          {/* {!user_details?.is_staff &&
            privileges?.includes("inventory.edit_inventory") && (
              <button className="eid" onClick={() => editRecord(record)}>
                <Edit />
              </button>
            )}
          {!user_details?.is_staff &&privileges?.includes("inventory.delete_inventory") && (
            <button className="del" onClick={() => deleteRecord(record)}>
              <Delete />
            </button>
          )} */}
        </div>
      ),
    },
  ];
  useEffect(() => {
    const getproductRecords = async () => {
      setLoading(true);
      const res = await GetAllProductInventory();
      setLoading(false);
      if (!res.success) {
        setLoading(false);
        toast.error(`Error`);
      }
    };
    getproductRecords();
  }, [GetAllProductInventory]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  return (
    <ServiceSection>
      {(user_details?.is_staff ||
        privileges?.includes("inventory.add_inventory")) && (
        <Row>
          <Col xs={24}>
            <div style={{ textAlign: "right", marginBottom: "15px" }}>
              <Button
                onClick={CreateService}
                icon={<Add style={{ marginRight: "8px" }} />}
                type="primary"
              >
                {" "}
                Add Inventory
              </Button>
            </div>
          </Col>
        </Row>
      )}

      <Table
        rowKey="id"
        style={{ overflowX: "auto" }}
        loading={loading}
        columns={recordColumn}
        dataSource={allProductInventory?.slice(
          (pagination.current - 1) * pagination.pageSize,
          pagination.current * pagination.pageSize
        )}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: false,
          showQuickJumper: false,
        }}
        onChange={handleTableChange}
      />
      <ProducesModal
        visible={visible}
        closeModal={closeModal}
        formMode={formMode}
        one_product_inventory={productRecord}
        CreateProductInventory={CreateProductInventory}
        UpdateProductInventory={UpdateProductInventory}
        GetAllProducts={GetAllProducts}
        allProducts={allProducts}
        GetAllRawMaterials={GetAllRawMaterials}
        allRawMaterials={allRawMaterials}
      />

      <ViewDetailsModal
        open={openDetails}
        closeModal={() => setOpenDetails(false)}
        details={productRecord}
      />
    </ServiceSection>
  );
};

const mapStateToProps = (state) => {
  return {
    allProductInventory: state.adminReducer.allProductInventory,
    allRawMaterials: state.adminReducer.allRawMaterials,
    allProducts: state.adminReducer.allProducts,
    one_service: state.adminReducer.one_service,
    my_roles: state.userManagementReducer.my_roles,
    user_details: state.authReducer.user_details,
  };
};

export default connect(mapStateToProps, {
  CreateProductInventory,
  UpdateProductInventory,
  GetAllProductInventory,
  DeleteProductInventory,
  GetOneConfiguredServices,
  GetAllRawMaterials,
  GetAllProducts,
})(Produces);
